import { render } from "./SingleLanguage.vue?vue&type=template&id=19a4c08c"
import script from "./SingleLanguage.vue?vue&type=script&lang=js"
export * from "./SingleLanguage.vue?vue&type=script&lang=js"

import "./SingleLanguage.vue?vue&type=style&index=0&id=19a4c08c&lang=scss"

import exportComponent from "/var/www/recruitment-form-front-end-master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__